import React, { Component, useEffect, useRef, useState } from "react";

import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { Button, Input, message, Table, Select } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import ProductsSelectWithFilter from "@/components/common/filters/ProductsSelectWithFilter";
import instance from "@/store/actions/instance";
import { setProductsUnits } from "@/store/actions";
import { getDefaultUnit } from "@/components/PurchaseOrders/newPurchaseOrderModal/AddPurchaseProductModal";
import products from "@/store/reducers/products";

const { Option } = Select;
const { Column } = Table;
const EditableContext = React.createContext();

const EditableRow = ({ index, ...props }) => {
  return (
    <EditableContext.Provider>
      <tr {...props} />
    </EditableContext.Provider>
  );
};

const EditableCell = ({
  editable,
  children,
  record,
  handleSave,
  direction,
  value,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef();
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
  };

  const save = (e) => {
    toggleEdit();
    if (e.target.value && e.target.value !== value) handleSave(e.target.value);
  };

  if (editable) {
    children = editing ? (
      <Input
        defaultValue={value}
        ref={inputRef}
        onPressEnter={save}
        onBlur={save}
        style={{ direction: direction }}
        min={0}
      />
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}
      >
        {value}
      </div>
    );
  }

  return <td {...restProps}>{children}</td>;
};

class TransferOrderProductsTable extends Component {
  state = { loading: false };
  addProduct = (product) => {
    const { units, allProducts } = this.props;
    const selectedProduct = allProducts.find(
      (p) => p.id === product.product_id
    );

    if (!selectedProduct) return null;
    let productUnits =
      selectedProduct?.units?.filter((u) => !u.is_deleted) || null;
    let baseUnit = units.find((u) => u.id === selectedProduct.unit);

    if (baseUnit && productUnits?.[0]?.id !== baseUnit.id) {
      productUnits.unshift({
        unit_id: baseUnit.id,
        unit__name: baseUnit.name,
        unt__ar_name: baseUnit.ar_name,
        conversion_factor: 1,
      });
    }

    let unit = (productUnits || []).find((u) => u.unit_id === product.unit_id);

    unit =
      unit ||
      getDefaultUnit(productUnits || [], baseUnit, "default_for_transfer");

    return {
      product__name: selectedProduct.name,
      product__ar_name: selectedProduct.ar_name,
      product__sku: selectedProduct.sku || "",
      product_id: selectedProduct.id,
      id: selectedProduct.id,
      key: selectedProduct.id,
      suppliersCost: product.cost_per_unit,
      quantity: product.quantity,
      supplierCode: product.supplier_code,
      unit_id: unit?.unit_id || unit?.id,
      conversion_factor: unit?.conversion_factor || 1,
      baseUnit: baseUnit,
      units: productUnits || null,
      type: "new-create",
    };
  };

  setCurrentProductsUnits = (productsUnits) => {
    const newProducts = this.props.products;
    Object.entries(productsUnits).forEach(([productId, units]) => {
      const product = newProducts.find(
        (p) => !p.is_deleted && p.product_id == productId
      );
      if (product) {
        product.units = units;
        if (product.product_unit_id) {
          product.units.unshift({
            unit__ar_name: product.product_unit_ar_name,
            unit__name: product.product_unit_name,
            unit_id: product.product_unit_id,
            conversion_factor: 1,
          });
        }
      }
    });
    this.props.setProducts(newProducts);
    this.props.setProductsUnits(productsUnits);
  };
  fetchProductsUnits = async (products, setLoading = this.props.setLoading) => {
    const { allProducts, units } = this.props;
    const newProducts = [...products];
    const productsIds = [];
    newProducts.forEach((p, index) => {
      if (!p.units) {
        const storeProduct = allProducts.find((sp) => sp.id === p.product_id);
        if (storeProduct?.units) {
          let baseUnit = units.find((u) => u.id === storeProduct.unit);
          newProducts[index].units = [...storeProduct.units];
          if (storeProduct.unit_id || baseUnit) {
            newProducts[index].units.unshift({
              unit_id: storeProduct.unid_id || baseUnit?.id,
              unit__name: storeProduct.unit__name || baseUnit?.name,
              unit__ar_name: storeProduct.unit__ar_name || baseUnit?.ar_name,
              coversion_factor: 1,
            });
          }
        } else {
          productsIds.push(p.product_id);
        }
      }
    });

    if (!productsIds?.length) return;
    const { t } = this.props;
    try {
      setLoading(true);
      const res = await instance.post(`/get_products_units/`, {
        productsIds,
      });
      this.setCurrentProductsUnits(res.data);

      setLoading(false);
      return res.data;
    } catch (err) {
      console.log(err);
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
    this.setState({ loading: false });
  };
  renderColumnDelete = (text, record, index) => {
    return (
      <Button
        disabled={record.type == "New"}
        onClick={() => {
          const newProducts = [...this.props.products];
          if (newProducts[index].type === "new-create") {
            newProducts.splice(index, 1);
          } else {
            newProducts[index].is_deleted = true;
          }
          this.props.setProducts(newProducts);
        }}
        danger
        shape="circle"
        icon={<DeleteOutlined style={{ top: 0 }} />}
      ></Button>
    );
  };

  renderColumnUnit = (unit, record, index) => {
    const { t, config, editMode, allProducts } = this.props;
    if (!editMode)
      return (
        <span>
          {(config.language === "arabic" && record.unit__ar_name) ||
            record.unit__name ||
            "-"}
        </span>
      );

    let productUnits = [];

    (record?.units || [])?.forEach((unit) => {
      const unitName =
        config.language == "arabic"
          ? unit.unit__ar_name || unit.unit__name
          : unit.unit__name;
      productUnits.push(
        <Option value={unit.unit_id} key={unit.unit_id}>
          {unitName}
        </Option>
      );
    });
    return productUnits.length ? (
      <Select
        style={{ width: "100%" }}
        placeholder={t("select a unit ")}
        defaultValue={record?.unit_id}
        onSelect={(unitId) => {
          const newProducts = [...this.props.products];
          const unit = record?.units.find((u) => u.unit_id === unitId);
          newProducts[index].unit_id = unit.unit_id;
          newProducts[index].conversion_factor = unit.conversion_factor || 1;
          this.props.setProducts(newProducts);
        }}
      >
        {productUnits}
      </Select>
    ) : (
      <span>
        {(config.language === "arabic" && record?.unit__ar_name) ||
          record.unit__name ||
          "-"}
      </span>
    );
  };
  renderColumnProduct = (productId, record, index) => {
    const { config, products } = this.props;
    if (record.type !== "New") {
      return (
        <span style={{ whiteSpace: "break-spaces" }}>
          {`${
            (config.language === "arabic" && record.product__ar_name) ||
            record.product__name
          } ${record.product__sku} `}
        </span>
      );
    }
    const currentProductsIds = products
      .filter((p) => !p.is_deleted)
      .map((p) => p.product_id);

    return (
      <ProductsSelectWithFilter
        loading={this.state.loading}
        onSelect={async (newSelectedProduct) => {
          const selectedProduct = this.props.allProducts.find(
            (p) => p.id === newSelectedProduct
          );
          const newProducts = [...this.props.products];
          await this.fetchProductsUnits(
            [{ product_id: selectedProduct.id }],
            (loading) => this.setState({ loading: loading })
          );

          const product = this.addProduct({
            product_id: selectedProduct.id,
            unit_id: selectedProduct.unit_id,
            cost_per_unit: selectedProduct.suppliers_price || 0,
            quantity: 1,
            supplier_code: "",
          });
          if (product) {
            newProducts.push(product);
          }

          await this.fetchProductsUnits(newProducts);

          this.props.setProducts(newProducts);
        }}
        customFilter={(p) =>
          p.type_of_product === "stocked" &&
          !p.is_deleted &&
          !currentProductsIds.includes(p.id)
        }
      />
    );
  };
  render() {
    const {
      t,
      products,
      selectedOrder,
      setProducts,
      config,
      isReceiving,
      editMode,
      permissions,
      isViewOnly,
    } = this.props;

    return (
      <div>
        {!editMode &&
          permissions.can_create_transfer_orders &&
          ["New"].includes(selectedOrder.status) &&
          !isViewOnly && (
            <Button
              icon={<EditOutlined />}
              onClick={() => {
                this.props.setEditMode(true);
                this.fetchProductsUnits(products.filter((p) => !p.is_deleted));
              }}
              className="my-2"
              style={{
                float: (config.language === "arabic" && "left") || "right",
              }}
            >
              {t("Edit")}
            </Button>
          )}
        <Table
          dataSource={
            editMode ? [...products, { type: "New", units: [] }] : products
          }
          pagination={false}
          rowClassName={(record, index) =>
            record.is_deleted ? "d-none" : "text-center editable-row"
          }
          components={{
            body: {
              row: EditableRow,
              cell: EditableCell,
            },
          }}
          className="my-3"
        >
          <Column
            title={t("Product")}
            key="product_id"
            dataIndex={"product_id"}
            render={(productId, record, index) =>
              this.renderColumnProduct(productId, record, index)
            }
          />
          {selectedOrder?.status === "New" && !editMode && (
            <Column
              title={t("Available Quantity")}
              dataIndex="available_inventory"
              key="available_inventory"
              render={(text, record) =>
                `${text || 0} ${
                  (config.language === "arabic" &&
                    record.product_unit_ar_name) ||
                  record.product_unit_name ||
                  ""
                }`
              }
            />
          )}
          <Column
            title={t("Sent Quantity")}
            dataIndex="quantity"
            key="quantity"
            onCell={(record, index) => ({
              record,
              editable: editMode && record.type !== "new",
              value: record.quantity,
              handleSave: (newQuantity) => {
                const newProducts = [...this.props.products];
                newProducts[index].quantity = newQuantity;
                this.props.setProducts(newProducts);
              },
            })}
            render={(text, record) =>
              `${text || "-"} ${
                (config.language === "arabic" && record.unit__ar_name) ||
                record.unit__name ||
                ""
              }`
            }
          />
          {editMode && (
            <Column
              title={t("Unit")}
              dataIndex="unit"
              key="unit"
              render={(unit, record, index) =>
                this.renderColumnUnit(unit, record, index)
              }
            />
          )}
          {!editMode && (
            <Column
              title={t("Received Quantity")}
              dataIndex="received_quantity"
              key="received_quantity"
              render={(text, record, index) =>
                `${text} ${
                  (config.language === "arabic" && record.unit__ar_name) ||
                  record.unit__name ||
                  ""
                }`
              }
              onCell={(record, index) => ({
                record,
                editable: isReceiving,
                value:
                  isReceiving && Number(record.new_received_quantity)
                    ? record.new_received_quantity
                    : record.received_quantity,
                handleSave: (newQuantity) => {
                  if (
                    !Number.isNaN(newQuantity) &&
                    parseInt(newQuantity) >= 0
                  ) {
                    const newProducts = [...products];
                    newProducts[index].new_received_quantity = Math.min(
                      Math.max(parseInt(newQuantity), record.received_quantity),
                      record.quantity
                    );
                    setProducts(newProducts);
                  }
                },
              })}
            />
          )}
          {editMode && (
            <Column
              title={t("Delete")}
              key="delete"
              render={this.renderColumnDelete}
            />
          )}
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
    allProducts: state.products.allProducts,
    units: state.products.units,
    settings: state.auth.settings,
    config: state.config,
    is_staff: state.auth.is_staff,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setProductsUnits: (payload) => dispatch(setProductsUnits(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(TransferOrderProductsTable));
